import React from 'react';
import { useNavigate } from 'react-router-dom';
import SocialFooter from '../components/SocialFooter';
import { ArrowLeft, EnvelopeSimple, Clock, Handshake } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";
const WOMAN_BOOK = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/wr554n4l_9F9CB5C5-F09E-4284-8C4F-B47BC346BEEA.jpeg";

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="contact-screen">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: `url(${LOGO_URL})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '50%' }} />

      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border px-6 py-4">
        <div className="max-w-2xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-card flex items-center justify-center" data-testid="back-btn">
            <ArrowLeft weight="bold" className="w-5 h-5 text-foreground" />
          </button>
          <img src={LOGO_URL} alt="Track365" className="w-40 h-auto" />
          <h1 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact Us</h1>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 relative z-10">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-foreground mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
            We're Here to Support Your Journey
          </h2>
          <p className="text-muted-foreground">
            If you have questions, feedback, or need help with your account, reach out anytime.
          </p>
        </div>

        <div className="space-y-6">
          <div className="premium-card p-6">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                <EnvelopeSimple weight="duotone" className="w-7 h-7 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="text-foreground font-semibold mb-1">General Support</h3>
                <a href="mailto:support@track365cardio.com" className="text-[#D4AF37] hover:underline text-lg">
                  support@track365cardio.com
                </a>
              </div>
            </div>
          </div>

          {/* Response Time with Image */}
          <div className="premium-card p-6">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                <Clock weight="duotone" className="w-7 h-7 text-[#D4AF37]" />
              </div>
              <div className="flex-1">
                <h3 className="text-foreground font-semibold mb-1">Response Time</h3>
                <p className="text-muted-foreground mb-3">Within 24–48 hours</p>
                <div className="rounded-xl overflow-hidden border border-[#D4AF37]/10 max-w-[200px]">
                  <img src={WOMAN_BOOK} alt="Track365 community" className="w-full h-auto object-contain" />
                </div>
              </div>
            </div>
          </div>

          <div className="premium-card p-6">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                <Handshake weight="duotone" className="w-7 h-7 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="text-foreground font-semibold mb-1">Business Inquiries & Partnerships</h3>
                <a href="mailto:business@track365cardio.com" className="text-[#D4AF37] hover:underline text-lg">
                  business@track365cardio.com
                </a>
              </div>
            </div>
          </div>

          <p className="text-center text-muted-foreground py-4">
            You can also contact us directly through the app under "Support."
          </p>

          <div className="text-center py-6 border-t border-border">
            <p className="text-[#D4AF37] font-semibold">
              We appreciate you being part of the Track365 community.
            </p>
          </div>

          <SocialFooter />
        </div>
      </main>
    </div>
  );
};

export default Contact;
